import { render, staticRenderFns } from "./clinicFeeManagement2.vue?vue&type=template&id=0bc28560&scoped=true"
import script from "./clinicFeeManagement2.vue?vue&type=script&lang=js"
export * from "./clinicFeeManagement2.vue?vue&type=script&lang=js"
import style0 from "./clinicFeeManagement2.vue?vue&type=style&index=0&id=0bc28560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc28560",
  null
  
)

export default component.exports